import { createSlice } from "@reduxjs/toolkit";

const customer = createSlice({
  name: "CUSTOMER",
  initialState: {
    recommendationData: null,
    addCustomerFlow: false,
    partnerFormLoading: true,
  },
  reducers: {
    setRecommendationData: (state, { payload }) => {
      state.recommendationData = payload;
    },
    setAddCustomerFlow: (state, { payload }) => {
      state.addCustomerFlow = payload;
    },
    setPartnerFormLoading: (state, { payload }) => {
      state.partnerFormLoading = payload;
    },
  },
});

export const customerActions = customer.actions;

export default customer;
